module.exports = __webpack_public_path__ + "static/media/icon-history-empty.90b0caae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-history-empty.svg
// module id = 2908
// module chunks = 0